"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var react_redux_1 = require("react-redux");
var entities_1 = __importDefault(require("../../entities"));
var _a = entities_1.default.selectors, selectSportBySportEvent = _a.selectSportBySportEvent, selectTournamentBySportEvent = _a.selectTournamentBySportEvent, selectMatch = _a.selectMatch;
var useSportEventSeoMicromarking = function (_a) {
    var sportEventId = _a.sportEventId;
    var _b = react_redux_1.useSelector(function (state) {
        return selectProps(state, { matchId: sportEventId });
    }), sport = _b.sport, sportEvent = _b.sportEvent, tournament = _b.tournament;
    if (!sport || !sportEvent || !tournament)
        return null;
    return {
        sport: sport,
        sportEvent: sportEvent,
        tournament: tournament,
    };
};
var selectProps = reselect_1.createStructuredSelector({
    sportEvent: selectMatch,
    sport: selectSportBySportEvent,
    tournament: selectTournamentBySportEvent,
});
exports.default = useSportEventSeoMicromarking;
//# sourceMappingURL=useSportEventSeoMicromarking.js.map